module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Additional Task Request")])], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.$sessionsStorage.get('allModuleIdMain') ?
        this.$sessionsStorage.get('allModuleIdMain') :
        '',
      "jobSeriesBanner": this.$sessionsStorage.get('JOBSERIES') ?
        this.$sessionsStorage.get('JOBSERIES') :
        '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [_c('b-card', {
    staticClass: "mt-2"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Assignment Details")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sm gutr mt-1 mb-1",
    attrs: {
      "id": "otherAdditionalTask"
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Job No.")]), _vm._v(" "), _c('th', [_vm._v("Job Date")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("POD")])]), _vm._v(" "), _vm._l((_vm.assignmentData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "error",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_c('h6', [_vm._v(_vm._s(item.Job_Series))])]), _vm._v(" "), _c('td', {
      staticClass: "error",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_c('h6', [_vm._v(_vm._s(item.JobDate))])]), _vm._v(" "), _c('td', {
      staticClass: "error",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_c('h6', [_vm._v(_vm._s(item.clientName))])]), _vm._v(" "), _c('td', {
      staticClass: "error",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_c('h6', [_vm._v(_vm._s(item.POD))])])])
  })], 2)]), _vm._v(" "), _c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Additional Task Details")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered gutr mt-1 mb-1"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Particulars")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Exp Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Bill To Customer")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Selling AMT")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                      Action\n                      "), _c('b-button', {
    attrs: {
      "id": "show-btn",
      "size": "sm",
      "variant": "primary",
      "disabled": _vm.assignmentData[0].Job_Series !=
        _vm.$sessionsStorage.get('JOBSERIES') ?
        true :
        false
    },
    on: {
      "click": _vm.addInvArry
    }
  }, [_vm._v("\n                        Add "), _c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)]), _vm._v(" "), _vm._l((_vm.lineADDTaskModalArray), function(itm, idx) {
    return _c('tr', {
      key: idx
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": itm.expenseId != '' ? true : false,
        "list": _vm.ledgerData,
        "option-value": "ledgerId",
        "option-text": "ledger",
        "placeholder": "Select "
      },
      model: {
        value: (itm.addTask_ledgerId),
        callback: function($$v) {
          _vm.$set(itm, "addTask_ledgerId", $$v)
        },
        expression: "itm.addTask_ledgerId"
      }
    }), _vm._v(" "), (itm.addTask_ledgerId_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.addTask_ledgerId_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "disabled": itm.expenseId != '' ? true : false,
        "formatter": _vm.capitalizeAll,
        "id": "amount",
        "name": "amount"
      },
      model: {
        value: (itm.addTask_amount),
        callback: function($$v) {
          _vm.$set(itm, "addTask_amount", $$v)
        },
        expression: "itm.addTask_amount"
      }
    }), _vm._v(" "), (itm.addTask_amount_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.addTask_amount_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-radio-group', {
      staticClass: "mb-3",
      attrs: {
        "options": _vm.SCCategoryList,
        "value-field": "SCVal",
        "text-field": "SCText"
      },
      on: {
        "input": function($event) {
          _vm.chnageSCCategoryList(
            itm.addTask_scCategory,
            itm.addTask_scCategory_err,
            itm.addTask_selling_amt,
            itm.addTask_selling_amt_err,
            _vm.lineADDTaskModalArray,
            idx,
            itm
          )
        }
      },
      model: {
        value: (itm.addTask_scCategory),
        callback: function($$v) {
          _vm.$set(itm, "addTask_scCategory", $$v)
        },
        expression: "itm.addTask_scCategory"
      }
    }), _vm._v(" "), (
      (itm.addTask_scCategory == '' ||
        itm.addTask_scCategory == null ||
        itm.addTask_scCategory == undefined) &&
      itm.addTask_scCategory_err != ''
    ) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.addTask_scCategory_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(itm.addTask_scCategory == 'Yes') ? _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "id": "amount",
        "name": "amount",
        "type": "number"
      },
      on: {
        "wheel": _vm.handleWheel,
        "input": function($event) {
          _vm.CheckValueNumbers($event)
        },
        "change": function($event) {
          _vm.CheckValueNumbers($event)
        }
      },
      model: {
        value: (itm.addTask_selling_amt),
        callback: function($$v) {
          _vm.$set(itm, "addTask_selling_amt", $$v)
        },
        expression: "itm.addTask_selling_amt"
      }
    }) : _vm._e(), _vm._v(" "), (itm.addTask_selling_amt_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.addTask_selling_amt_err))]) : (itm.addTask_scCategory == 'No') ? _c('span', [_vm._v("No")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-textarea', {
      attrs: {
        "disabled": itm.expenseId != '' ? true : false,
        "formatter": _vm.capitalizeAll,
        "id": "remark",
        "name": "remark"
      },
      model: {
        value: (itm.addTask_remark),
        callback: function($$v) {
          _vm.$set(itm, "addTask_remark", $$v)
        },
        expression: "itm.addTask_remark"
      }
    }), _vm._v(" "), (itm.addTask_remark_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.addTask_remark_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-button', {
      staticClass: "ml-auto",
      attrs: {
        "disabled": itm.expenseId != '' ? true : false,
        "id": "show-btn",
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          _vm.removeInvArry(idx)
        }
      }
    }, [_vm._v("\n                        Remove\n                        "), _c('i', {
      staticClass: "fa fa-minus",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), (
      _vm.$sessionsStorage.get('designation') == 'Admin' &&
      _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' && itm.expenseId
    ) ? _c('b-button', {
      staticClass: "ml-auto",
      attrs: {
        "id": "show-btn",
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          _vm.removeAdditionalTask(itm)
        }
      }
    }, [_vm._v("\n                        Remove Admin\n                        "), _c('i', {
      staticClass: "fa fa-minus",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()], 1)])
  })], 2)])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "5"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "2"
    }
  }, [(_vm.lineADDTaskModalArray.length > 0) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "size": "sm",
      "variant": "primary",
      "id": "addButtonLoaderSB",
      "disabled": _vm.assignmentData[0].Job_Series != _vm.$sessionsStorage.get('JOBSERIES') ?
        true :
        false
    },
    on: {
      "click": _vm.addADDTaskDetail
    }
  }, [_vm._v("Save & Submit\n                ")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderSB"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "5"
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMailAfter",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5251ea84","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/AdditionalTask.vue
// module id = 2626
// module chunks = 0